export default "__VITE_ASSET__2r$90o1___"